/**
 * Shared display-only label formatters (Jun 2026).
 * Stored values are never changed — these only affect rendering.
 */
export const titleCaseLabel = (v) =>
  (v || '').replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

// "supervisor" → "Supervisor", "billing_manager" → "Billing Manager"
export const formatRoleName = titleCaseLabel;

// "active" → "Active", "on_hold" → "On Hold", "waitlist" → "Waitlist"
export const formatClientStatus = titleCaseLabel;
